<div class="w-full flex justify-center">
	<div class="max-w-[1800px] w-full">
		<zaeper-page-layout [navigation]="navigation" [pageLayout]="ePageLayout.CARDS"
							[title]="'manage-features' | zDictionary">
			<ng-template zTemplate="header">
				<zaeper-icon fontSet="material-icons-outlined">star_outline</zaeper-icon>
			</ng-template>

			<div class="flex flex-col gap-6">
				@if (isNewStarterPackage()) {
					<div class="flex items-center gap-3 px-4 py-3 rounded-md bg-primary/10 text-primary border border-primary/20">
						<i class="pi pi-gift text-xl"></i>
						<span><span class="font-semibold">Starter-Paket aktiv</span> — Ihr aktuelles Paket enthält 1 Cloud, 1 Gruppe, 1 Receiver und 1 Benutzer und ist kostenlos. Sobald Sie eine dieser Lizenzen erhöhen, wechseln Sie automatisch in ein kostenpflichtiges Modell.</span>
					</div>
				}
				@if (activeLicense$ | async; as license) {
					<p-card>
						<div class="flex flex-wrap items-center justify-between gap-4 mb-6">
							<div class="text-xl font-semibold">Kostenübersicht</div>
							<p-selectbutton
								[options]="intervalOptions"
								[ngModel]="billingInterval()"
								(ngModelChange)="billingInterval.set($event)"
								[allowEmpty]="false"
								optionLabel="label"
								optionValue="value"
							/>
						</div>
						<zaeper-card-group styleClass="grid grid-cols-2 md:grid-cols-4 gap-4">
							@for (card of pricingCards(); track card.label) {
								<p-card styleClass="shadow-sm">
									<div class="flex flex-col items-center justify-center text-center p-2">
										<i [class]="card.icon + ' text-3xl mb-2 text-primary'"></i>
										<span class="text-sm text-surface-500 dark:text-surface-400">{{ card.label }}</span>
										<div class="flex items-center gap-2 mt-1">
											@let changed = card.newQuantity !== card.currentQuantity || card.newInterval !== card.currentInterval;
											<span class="text-xl font-normal" [class.line-through]="changed" [class.text-surface-400]="changed">
												{{ format(card.currentUnitPrice * card.currentQuantity) }}
											</span>
											@if (changed) {
												<i class="pi pi-arrow-right text-xs text-surface-400"></i>
												<span class="text-xl font-normal" [class]="card.newQuantity > card.currentQuantity ? 'text-primary' : 'text-green-500'">
													{{ format(card.newUnitPrice * card.newQuantity) }}
												</span>
											}
										</div>
										<span class="text-xs text-surface-400">{{ format(card.newUnitPrice) }} / {{ card.newInterval === 'YEARLY' ? 'Jahr' : 'Monat' }}</span>
									</div>
								</p-card>
							}
						</zaeper-card-group>
					</p-card>

					<p-card>
						<div class="text-xl font-semibold mb-6">Lizenzen</div>
						<div class="flex flex-col gap-8">
							<div class="flex flex-col gap-2">
								<span class="font-medium text-lg">Clouds</span>
								<div class="flex items-center gap-4">
									<input type="number" [ngModel]="maxClouds()" (ngModelChange)="clampAndSet(maxClouds, $event, 1, 100)" min="1" max="100" class="w-16 text-center text-sm font-semibold border border-surface-300 dark:border-surface-600 rounded-md px-2 py-1 bg-transparent" />
									<div class="flex-1 flex flex-col gap-1">
										<p-slider [ngModel]="maxClouds()" (ngModelChange)="maxClouds.set($event)" [min]="1" [max]="100" />
										<div class="flex justify-between text-sm text-surface-400">
											<span>1</span>
											<span>100</span>
										</div>
									</div>
								</div>
							</div>

							<div class="flex flex-col gap-2">
								<span class="font-medium text-lg">Gruppen</span>
								<div class="flex items-center gap-4">
									<input type="number" [ngModel]="maxGroups()" (ngModelChange)="clampAndSet(maxGroups, $event, 1, 100)" min="1" max="100" class="w-16 text-center text-sm font-semibold border border-surface-300 dark:border-surface-600 rounded-md px-2 py-1 bg-transparent" />
									<div class="flex-1 flex flex-col gap-1">
										<p-slider [ngModel]="maxGroups()" (ngModelChange)="maxGroups.set($event)" [min]="1" [max]="100" />
										<div class="flex justify-between text-sm text-surface-400">
											<span>1</span>
											<span>100</span>
										</div>
									</div>
								</div>
							</div>

							<div class="flex flex-col gap-2">
								<span class="font-medium text-lg">Receivers</span>
								<div class="flex items-center gap-4">
									<input type="number" [ngModel]="maxReceivers()" (ngModelChange)="clampAndSet(maxReceivers, $event, 1, 100)" min="1" max="100" class="w-16 text-center text-sm font-semibold border border-surface-300 dark:border-surface-600 rounded-md px-2 py-1 bg-transparent" />
									<div class="flex-1 flex flex-col gap-1">
										<p-slider [ngModel]="maxReceivers()" (ngModelChange)="maxReceivers.set($event)" [min]="1" [max]="100" />
										<div class="flex justify-between text-sm text-surface-400">
											<span>1</span>
											<span>100</span>
										</div>
									</div>
								</div>
							</div>

							<div class="flex flex-col gap-2">
								<span class="font-medium text-lg">Anwender</span>
								<div class="flex items-center gap-4">
									<input type="number" [ngModel]="maxUsers()" (ngModelChange)="clampAndSet(maxUsers, $event, 1, 100)" min="1" max="100" class="w-16 text-center text-sm font-semibold border border-surface-300 dark:border-surface-600 rounded-md px-2 py-1 bg-transparent" />
									<div class="flex-1 flex flex-col gap-1">
										<p-slider [ngModel]="maxUsers()" (ngModelChange)="maxUsers.set($event)" [min]="1" [max]="100" />
										<div class="flex justify-between text-sm text-surface-400">
											<span>1</span>
											<span>100</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</p-card>
				}

				<p-card>
					<div class="text-xl font-semibold mb-4">Features</div>
					<p-table [tableStyle]="{ 'min-width': '50rem' }" [value]="features()">
						<ng-template pTemplate="header">
							<tr>
								<th>Name</th>
								<th class="w-1/2">Beschreibung</th>
								<th>Status</th>
							</tr>
						</ng-template>
						<ng-template let-feature pTemplate="body">
							<tr>
								<td class="text-nowrap"><strong>{{ feature.name }}</strong></td>
								<td class="w-full"><i>{{ feature.description }}</i></td>
								<td>
									<p-toggleswitch
										[ngModel]="feature.enabled"
										(ngModelChange)="onFeatureToggle(feature.featureId, $event)"
										[disabled]="feature.locked"
									/>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</p-card>

				<div class="flex flex-wrap justify-end items-center gap-4">
					@if (prices(); as priceList) {
						<span class="text-sm text-surface-500 dark:text-surface-400">
							Preise in {{ priceList.currency }}, exkl. MWST{{ priceList.currencyFixed ? '. Die Währung ist mit dem ersten Abonnement festgelegt.' : '.' }}
						</span>
					}
					<div class="flex items-center gap-2">
						<span class="text-surface-500">Gesamt aktuell:</span>
						@if (totalCurrentPrice() > 0 || totalCurrentYearlyPrice() === 0) {
							<span class="text-xl font-normal">{{ format(totalCurrentPrice()) }} / Monat</span>
						}
						@if (totalCurrentYearlyPrice() > 0) {
							<span class="text-xl font-normal">@if (totalCurrentPrice() > 0) {+ }{{ format(totalCurrentYearlyPrice()) }} / Jahr</span>
						}
					</div>
					@if (totalNewPrice() !== totalCurrentPrice() || totalNewYearlyPrice() !== totalCurrentYearlyPrice()) {
						<div class="flex items-center gap-2">
							<i class="pi pi-arrow-right text-surface-400"></i>
							<span class="text-surface-500">Neu:</span>
							@if (totalNewPrice() > 0 || totalNewYearlyPrice() === 0) {
								<span class="text-xl font-normal text-primary">
									{{ format(totalNewPrice()) }} / Monat
								</span>
							}
							@if (totalNewYearlyPrice() > 0) {
								<span class="text-xl font-normal text-primary">
									@if (totalNewPrice() > 0) {+ }{{ format(totalNewYearlyPrice()) }} / Jahr
								</span>
							}
						</div>
					}
					<!-- Disabled with the role it needs: buying needs Manager, going back to the free package Admin. -->
					<span class="inline-flex" [pTooltip]="requiredRole() ? (requiredRole() | zRole: 'hint') : undefined" tooltipPosition="top">
						<p-button
							label="Übernehmen"
							[rounded]="true"
							[disabled]="!hasChanges() || isSaving() || !!requiredRole()"
							[loading]="isSaving()"
							(onClick)="save()"
						></p-button>
					</span>
				</div>
			</div>
		</zaeper-page-layout>
	</div>
</div>
